export function OarEsperia() {
  return (
    <svg
      width="312.72833"
      height="650"
      viewBox="0 0 82.742702 171.97917"
      version="1.1"
      id="esperia"
    >
      <defs id="defs1" />
      <g id="layer1">
        <rect
          fill="#ffffff"
          id="rect1"
          width="82.742706"
          height="171.97917"
          x="-0.19270325"
          y="1.527482e-14"
        />
        <rect
          fill="#3626ff"
          id="rect2"
          width="82.550003"
          height="12.442918"
          x="-7.6910867e-16"
          y="35.296532"
        />
        <rect
          fill="#fcff26"
          id="rect2-8"
          width="82.550003"
          height="12.442918"
          x="-7.6910867e-16"
          y="22.853613"
        />
      </g>
    </svg>
  );
}
